import React, {Component} from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import {CenterEmpty, CenterLoading, decodeTool, uu_id} from "../App";
import Card from "@mui/material/Card";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import {
    AddCircleOutline, ArrowBack,
    CommentOutlined,
    ContentCut,
    DeleteOutline,
    Done,
    DoneOutline,
    DownloadOutlined,
    MoreVertOutlined,
    PeopleOutline,
    PlayCircleOutline,
    PlusOne,
    PostAdd,
    PostAddOutlined,
    RemoveCircle,
    SendOutlined,
    TagOutlined,
    VideocamOutlined,
    Visibility,
    VisibilityOff
} from "@mui/icons-material";
import {
    Avatar,
    Badge, Button, CardActionArea,
    CardActions, CardContent, CardHeader, CardMedia, Chip,
    CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Fade,
    FormControl, FormControlLabel, Grid,
    IconButton, ImageListItem, ImageListItemBar,
    InputAdornment,
    InputLabel,
    ListItem, ListItemAvatar, ListItemIcon, ListItemText, makeStyles, Menu, MenuItem, MenuList,
    OutlinedInput, Paper, Stack, styled, Switch, TextField, Tooltip
} from "@mui/material";
import BottomSheet from "../assets/bottom_sheet_mui/src/components/BottomSheet/BottomSheet";
import {Appbar} from "react-native-paper";
import {Link} from "react-router-dom";
import {Text} from "react-native-web";
import * as Icons from "@mui/icons-material";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Backdrop from "@mui/material/Backdrop";
import ListItemButton from "@mui/material/ListItemButton";
import CryptoJS from "react-native-crypto-js";

const ListItemNew = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
}));

const dialogAdd = styled('paper')(({ theme }) => ({
    position: "absolute",
    left: 0,
    bottom: 0
}));

let isAndroid = false;
let isIos = false;
export default class Community extends Component {

    componentDidMount() {
        document.getElementById("actionBar").style.display = "block";
        window.community = this;

        const passhash = CryptoJS.MD5(navigator.userAgent).toString();
        window.CryptoJS = CryptoJS;
        if (passhash === "875872353699da983cbd784affaf1a6d") {
            isAndroid = true;
            isIos = false;
            document.title = "SAnime | اس أنمي | ANDROID";
        } else if (passhash === "30a0d5eb921ede79fd4690bad5a6928a") {
            isAndroid = false;
            isIos = true;
            document.title = "SAnime | اس أنمي | IOS";
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: [],
            story: [],
            error: false,
            postItem: {
                post: "",
                hasFire: false,
                hasAnime: false,
                hasImage: "",
                anime: [],
                youtube: "",
                userAddress: localStorage.getItem("userAddress")
            },
            postStory: {
                post: "",
                hasImage: "",
                userAddress: localStorage.getItem("userAddress")
            },
            addPost: false,
            comment: false,
            commentData: [],
            commentLoading: true,
            commentString: "",
            postComment: {
                post: "",
                id: ""
            },
            userData: {
                userimage: "",
                userId: "",
                admin: false
            },
            anchorEl: null,
            menuOpen: false,
            menuId: "",
            idForAdd: "",
            idForAddOpen: false,
            idForOpened: false,
            animeList: [],
            backdrop: false,
            menuPost: false,
            bottomStory: false,
            storyDataDialog: false,
            storyData: {
                image: "",
                time: "",
                user: "",
                text: "",
                hasPremium: "0",
                userimage: ""
            },
            bannedList: ""
        };
        this.prepare();
    }

    storyDataDialogClose = () => {
        this.setState({
            storyDataDialog: false,
        })
    }

    storyDataDialogOpen = (item) => {
        this.setState({
            storyDataDialog: true,
            storyData: {
                image: item.hasImage,
                time: item.time,
                user: item.username,
                text: item.post,
                hasPremium: item.hasPremium,
                userImage: item.userimage
            }
        });
        this.prepare();
    }

    epMenuClose = () => {
        this.setState({
            menuPost: false
        });
    }
    epMenuOpen = () => {
        this.openAdd();
    }

    storyAdd = () => {
        this.epMenuClose();
        this.setState({
            bottomStory: true
        });
    }

    closeStory = () => {
        this.setState({
            bottomStory: false,
            postStory: {
                post: "",
                hasImage: "",
            },
        });
    }

    openIdForOpened = () => {
        this.setState({
            idForOpened: false,
            animeList: [],
            backdrop: true,
            idForAddOpen: false,
        });
        fetch('https://app.sanime.net/function/h10.php?page=search&name='+this.state.idForAdd).then((value) => {
            value.text().then((value) => {
                let JS = JSON.parse(decodeTool(value));
                this.setState({
                    idForOpened: true,
                    animeList: JS,
                    backdrop: true,
                });
            });
        }).catch((error) => {
            this.setState({
                backdrop: false,
            });
        });
    }
    closeIdForOpened = () => {
        this.setState({
            idForOpened: false,
            animeList: [],
            backdrop: false,
        });
    }

    bannedUsers = (user) => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
        window.react.setState({
            backdrop: true,
        });
        let data = JSON.parse(localStorage.getItem("loggedData"));
        fetch('https://app.sanime.net/function/h10.php?page=bannedUserHere', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `password=${encodeURIComponent(data.password)}&email=${encodeURIComponent(data.email)}&userId=${encodeURIComponent(user.userIp)}`
        }).then((response) => {
            response.text().then((va) => {
                Swal.fire(va);
                this.prepare();
            });
        }).catch((err) => {
            Swal.fire("توجد مشكلة حاول مجددا");
            this.prepare();
        });
    }

    deletePost = () => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            window.react.setState({
                backdrop: true,
            });
            fetch('https://app.sanime.net/function/h10.php?page=deletePost', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    password: data.password,
                    email: data.email,
                    userId: data.id,
                    id: this.state.menuId
                })
            }).then((response) => {
                response.json().then((va) => {
                    if (va.status === 1) {
                        Swal.fire(va.message);
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'حدثت مشكلة',
                            text: va.message,
                        });
                    }
                    this.prepare();
                });
            }).catch((err) => {
                Swal.fire("توجد مشكلة حاول مجددا");
                this.prepare();
            });
        } else {
            Swal.fire("توجد مشكلة حاول مجددا");
            this.prepare();
        }
    }
    closeMenu = (item) => {
        this.setState({
            anchorEl: null,
            menuOpen: false,
        });
    }
    menuClicked = (event) => {
        this.setState({
            anchorEl: event.currentTarget,
            menuOpen: true,
            menuId: event.currentTarget.id
        });
    }
    changedComment = (value) => {
        this.setState({
            commentString: value.target.value,
            postComment: {
                post: value.target.value,
                id: this.state.postComment.id
            },
        });
    }

    goBack = () => {
        history.back();
    }

    checkTheme = () => {
        if (localStorage.getItem("darkMode") == null) {
            return true;
        } else {
            if (localStorage.getItem("darkMode").includes("true")) {
                return true;
            } else {
                return false;
            }
        }
    }
    prepare = () => {
        if (isAndroid) {
            //Android.code("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");
        }
        setTimeout(() => {
            window.react.setState({
                homeTitle: "المجتمع"
            });
            fetch('https://app.sanime.net/function/h10.php?page=getPost').then((response) => {
                response.text().then((va) => {
                    const list = JSON.parse(va);
                    this.setState({
                        loading: false,
                        data: list["list"],
                        story: list["story"],
                        bannedList: list["banned"]
                    });
                    if (localStorage.getItem("userAddress") != null) {
                        if (list["banned"].toString().includes(localStorage.getItem("userAddress"))) {
                            Swal.fire("أنت محظور");
                            history.back();
                        }
                    }
                    window.react.setState({
                        backdrop: false,
                    });
                });
            }).catch((err) => {
                window.react.setState({
                    backdrop: false,
                });
            });
            if (localStorage.getItem("logged") !== null) {
                let data = JSON.parse(localStorage.getItem("loggedData"));
                this.setState({
                    userData: {
                        userimage: data.image,
                        userId: data.id,
                        admin: data.isAdmin.toString().includes("true")
                    }
                });
            }

        },100);
    }

    changeFire = (index) => {
        this.state.data[index].hasFire = !this.state.data[index].hasFire;
        const newValue = this.state.data;
        this.setState({
            data: newValue
        });
    }

    showAds = () => {
        //Android.code("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");
    }

    sendPost = () => {
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            const formData = new URLSearchParams();
            formData.append('email', data.email);
            formData.append('password', data.password);
            formData.append('item', btoa(unescape(encodeURIComponent(JSON.stringify(this.state.postItem)))));
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData
            };
            this.setState({
                addPost: false,
                postItem: {
                    post: "",
                    hasFire: false,
                    hasAnime: false,
                    hasImage: "",
                    anime: [],
                    youtube: "",
                    userAddress: localStorage.getItem("userAddress")
                },

            });
            window.react.setState({
                backdrop: true,
            });
            fetch('https://app.sanime.net/function/h10.php?page=sendPost', requestOptions).then((response) => {
                response.json().then((va) => {
                    if (va.status === 1) {
                        Swal.fire(va.message);
                        setTimeout(() => {
                            if (localStorage.getItem("logged") !== null) {
                                let data = JSON.parse(localStorage.getItem("loggedData"));
                                if (!window.react.state.premium.includes(data.email)) {
                                    window.react.openFullscreen();
                                }
                            } else {
                                window.react.openFullscreen();
                            }
                        },1000);
                        if (isAndroid) {
                            if (localStorage.getItem("logged") !== null) {
                                let data = JSON.parse(localStorage.getItem("loggedData"));
                                if (!window.react.state.premium.includes(data.email)) {
                                    this.showAds();
                                }
                            } else {
                                this.showAds();
                            }
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'حدثت مشكلة',
                            text: va.message,
                        });
                    }
                    this.prepare();
                });
            }).catch((err) => {
                Swal.fire("توجد مشكلة حاول مجددا");
                this.prepare();
            });
        } else {
            Swal.fire("يجب عليك تسجيل الدخول للنشر");
        }
    }

    restartPage = () => {
        this.setState({
            loading: true,
            error: false
        });
        setTimeout(()=> {
            this.prepare();
        },500);
    }
    closeAdd = () => {
        this.setState({
            addPost: false,
        })
    }
    openAdd = () => {
        if (localStorage.getItem("logged") !== null) {
            this.setState({
                addPost: true,
            });
        } else {
            Swal.fire("يجب عليك تسجيل الدخول للنشر");
        }
        this.epMenuClose();
    }

    IdForAddChanged = (value) => {
        this.setState({
            idForAdd: value.target.value,
        });
    }

    closeIdForAdd = () => {
        this.setState({
            idForAddOpen: false,
            backdrop: false,
            idForAdd: "",
        });
    }

    openIdForAdd = () => {
        this.setState({
            idForAddOpen: true,
        });
    }

    IdForAdd = (id) => {
        let newData = JSON.parse('{}');
        newData.id = id;
        if (!this.state.postItem.anime.some(item => item.id === newData.id)) {
            this.state.postItem.anime.push(newData);
            const newValue = this.state.postItem;
            this.setState({
                postItem: newValue,
                idForAdd: '',
            });
            this.closeIdForAdd();
            this.closeIdForOpened();
        } else {
            this.closeIdForAdd();
            this.closeIdForOpened();
            //Swal.fire('المعرف مضاف');
        }
    }

    changedPost = (value) => {
        this.state.postItem.post = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }

    changedPostStory = (value) => {
        this.state.postStory.post = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postStory: newValue
        });
    }

    changedImageStory = (value) => {
        this.state.postStory.hasImage = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postStory: newValue
        });
    }

    changedYoutube = (value) => {
        this.state.postItem.youtube = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }

    changedImage = (value) => {
        this.state.postItem.hasImage = value.target.value;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }

    hasFireChanged = (value) => {
        this.state.postItem.hasFire = value.target.checked;
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }

    deleteAnimeId = (data) => {
        this.state.postItem.anime = this.state.postItem.anime.filter((chip) => chip.id !== data.id);
        const newValue = this.state.postItem;
        this.setState({
            postItem: newValue
        });
    }
    showComment = (item) => {
        window.react.setState({
            backdrop: true,
        });
        this.setState({
            postComment: {
                post: "",
                id: this.state.data[item].id
            },
        });
        this.prepare();
        fetch('https://app.sanime.net/function/h10.php?page=getCmd&id=' + this.state.data[item].id).then((response) => {
            response.text().then((va) => {
                if (va.includes('Post Deleted')) {
                    Swal.fire("المنشور محذوف")
                } else {
                    this.setState({
                        comment: true,
                        commentData: JSON.parse(va),
                        commentLoading: false,
                    });
                    setTimeout(() => {
                        if (this.checkTheme()) {
                            document.getElementById("addCmd").setAttribute("style","color: white;");
                        } else {
                            document.getElementById("addCmd").setAttribute("style","color: black;");
                        }
                    },100);
                }
                window.react.setState({
                    backdrop: false,
                });
            });
        }).catch((err) => {
            window.react.setState({
                backdrop: false,
            });
            Swal.fire("توجد مشكلة حاول مجددا");
        });
    }
    closeComment = () => {
        this.setState({
            comment: false,
            commentData: [],
            commentLoading: true,
        });
    }
    sendCmd = () => {
        if (this.state.commentString.length < 2) {
            alert("يجب على تعليقك أن يكون حرفين أو أكثر");
        } else {
            if (localStorage.getItem("logged") !== null) {
                window.react.setState({
                    backdrop: true,
                });
                this.setState({
                    comment: false,
                    commentData: [],
                    commentLoading: false,
                });
                let data = JSON.parse(localStorage.getItem("loggedData"));
                const formData = new URLSearchParams();
                formData.append('email', data.email);
                formData.append('password', data.password);
                formData.append('item', btoa(unescape(encodeURIComponent(JSON.stringify(this.state.postComment)))));
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: formData
                };
                window.react.setState({
                    backdrop: true,
                });
                fetch('https://app.sanime.net/function/h10.php?page=addCmdPost', requestOptions).then((response) => {
                    response.json().then((va) => {
                        if (va.status === 1) {
                            Swal.fire(va.message);
                            this.setState({
                                comment: true,
                                commentData: va.list,
                                commentLoading: false,
                                commentString: ""
                            });
                        } else {
                            this.setState({
                                comment: false,
                                commentLoading: false,
                                commentString: ""
                            });
                            Swal.fire({
                                icon: 'error',
                                title: 'حدثت مشكلة',
                                text: va.message,
                            });
                        }
                        this.prepare();
                    });
                }).catch((err) => {
                    this.setState({
                        comment: false,
                        commentLoading: false,
                        commentString: ""
                    });
                    Swal.fire("توجد مشكلة حاول مجددا");
                    this.prepare();
                });
            } else {
                this.setState({
                    comment: false,
                    commentData: [],
                    commentLoading: false,
                });
                Swal.fire("يجب عليك تسجيل الدخول لأضافة تعليق");
            }
        }
    }
    isMe = (item) => {
        if (this.state.userData.admin) {
            return true;
        } else {
            return this.state.userData.userId + this.state.userData.userimage === item.userId + item.userimage;
        }
    }

    isAdmin = () => {
        if (localStorage.getItem("logged") !== null) {
            let data = JSON.parse(localStorage.getItem("loggedData"));
            if (data.isAdmin.includes("true")) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    render() {
        if (this.state.loading) {
            return <CenterLoading/>
        } else {
            return <Box style={{marginTop: '0px',marginBottom: '7px'}} height={'100%'}>
                {this.state.data.length === 0 ? <CenterEmpty/> : <Box/>}
                <Container sx={{paddingLeft: "0px",paddingRight: "0px"}}>
                    <List style={{paddingTop: "0px"}}>
                        {
                            this.state.data.map( (item, index) =>
                                <ListItem style={{paddingLeft: "7px", paddingRight: "7px"}} key={item.id}>
                                    <Card sx={{ width: "100%",borderRadius: "8px" }}>
                                        <CardHeader
                                            avatar={
                                                item.admin.toString().includes("true") ? <Tooltip title="الأدارة">
                                                    <Badge anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    }} badgeContent={<Done style={{color: 'white'}} sx={{ fontSize: 12 }}/>} overlap="circular" sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 14, minWidth: 14, width: 14 } }} color="primary">
                                                        <Avatar aria-label="recipe" src={item.userimage}/>
                                                    </Badge>
                                                </Tooltip> : <Avatar aria-label="recipe" src={item.userimage}/>
                                            }
                                            action={
                                                this.isMe(item) ? <IconButton aria-label="settings" id={item.id} onClick={this.menuClicked}>
                                                    <MoreVertOutlined />
                                                </IconButton> : <Box/>
                                            }
                                            title={item.hasPremium !== "1" ? <Box>
                                            <span style={this.checkTheme() ? {color: "white"} : {color: "black"} }>
                                                {item.username}
                                            </span>
                                            </Box> : <Box>
                                            <span style={{color: "gold", textShadow: '0px 0px 5px #ffeb3b'}}>
                                                {item.username}
                                            </span>
                                            </Box>}
                                            subheader={<Typography style={{fontSize: "14px",opacity: "0.8"}}>{item.time}</Typography>}
                                        />
                                        {this.state.menuId === item.id ? <Menu
                                            id={item.id}
                                            anchorEl={this.state.anchorEl}
                                            open={this.state.menuOpen}
                                            onClose={this.closeMenu}
                                            MenuListProps={{
                                                'aria-labelledby': item.id,
                                            }}
                                            TransitionComponent={Fade}
                                        >
                                            <MenuItem onClick={this.deletePost}>
                                                <ListItemIcon>
                                                    <DeleteOutline fontSize="small" />
                                                </ListItemIcon>
                                                <ListItemText>حذف</ListItemText>
                                            </MenuItem>
                                            {
                                                this.isAdmin() ? <MenuItem onClick={this.bannedUsers.bind(this,item)}>
                                                    <ListItemIcon>
                                                        <RemoveCircle fontSize="small" />
                                                    </ListItemIcon>
                                                    <ListItemText>حظر</ListItemText>
                                                </MenuItem> : <Box/>
                                            }
                                        </Menu> : <Box/> }
                                        <CardContent style={{textAlign: "unset",paddingTop: "1px",paddingBottom: "3px"}} dir="auto">
                                            {
                                                item.hasFire ? <Button style={{width: "100%",color: "#ff0000"}} onClick={this.changeFire.bind(this,index)}>المنشور يحتوي على حرق (اضغط للمشاهدة)</Button> :
                                                    <Typography style={{width: "100%",textAlign: "initial",whiteSpace: "pre-line"}} dir="auto" aria-multiline={true}>{item.post}</Typography>
                                            }
                                        </CardContent>
                                        {
                                            item.youtube.length === 0 ? <Box/> : <List>
                                                <ListItem component="div">
                                                    <Container disableGutters>
                                                        <Card style={{alignItems: "center"}}>
                                                            <div style={{borderRadius: '10px',overflow: 'hidden',width: "100%",display: "flex", height: "fit-content"}}>
                                                                <iframe style={{width: "100%"}} height="230" src={item.youtube} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
                                                            </div>
                                                        </Card>
                                                    </Container>
                                                </ListItem>
                                            </List>
                                        }
                                        {
                                            item.hasImage.length === 0 ? <Box/> : <CardMedia
                                                component="img"
                                                image={item.hasImage}
                                                onError={(event) => event.target.style.display = 'none'}
                                                onLoad={(event) => {
                                                    event.target.style.display = 'inline-block';
                                                }}
                                                alt={item.username}
                                            />
                                        }
                                        <ListItem component="div" style={{padding: '0px'}}>
                                            <Container disableGutters>
                                                <div className="scrollmenu" style={this.checkTheme() ? {backgroundColor: '#2d3b46',borderRadius: "8px",margin: "6px"} : {backgroundColor: '#f8f6f6',borderRadius: "8px",margin: "6px"}}>
                                                    {item.anime.map((step, index) => (
                                                        <div key={step.id}>
                                                            <Card style={{margin: "6px"}} sx={{ height: 200, width: 112 }} >
                                                                <Link to={'/info?id='+step.id} style={{color: 'unset',cursor: 'unset', textDecoration: 'unset'}}>
                                                                    <CardActionArea>
                                                                        <CardMedia
                                                                            component="img"
                                                                            height="175"
                                                                            image={step.image}
                                                                            alt={step.name}
                                                                        />
                                                                        <Divider sx={{height: 1.2}} color={'#00b2ff'}/>
                                                                        <Stack style={{paddingLeft: '4px',paddingBottom: '3px',paddingTop: '1px'}} spacing={0}>
                                                                            <Typography style={{textOverflow: "ellipsis",overflow: "hidden",fontSize: '14px',whiteSpace: "nowrap"}}>{step.name}</Typography>
                                                                        </Stack>
                                                                    </CardActionArea>
                                                                </Link>
                                                            </Card>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Container>
                                        </ListItem>
                                        <CardActions disableSpacing sx={{justifyContent: "space-between"}}>
                                            <IconButton onClick={this.showComment.bind(this,index)}>
                                                <Badge badgeContent={item.commant.length.toString()} color="primary">
                                                    <CommentOutlined color="action" />
                                                </Badge>
                                            </IconButton>
                                            <Tooltip title={"معرف المستخدم"}>
                                            <span style={this.checkTheme() ? {color: "white", opacity: "0.5"} : {color: "black",opacity: "0.5"} }>
                                            {item.userId}#
                                        </span>
                                            </Tooltip>
                                        </CardActions>
                                    </Card>
                                </ListItem>
                            )
                        }
                    </List>
                </Container>
                <Dialog open={this.state.idForAddOpen} onClose={this.closeIdForAdd}>
                    <List style={this.state.isDark ? {backgroundColor: "#252e39"} : {backgroundColor: "#ffffff"}}>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.state.isDark ? {color: 'white'} : {color: 'black'}}>كتابة أسم الأنمي</InputLabel>
                                <OutlinedInput
                                    style={this.state.isDark ? {color: 'white'} : {color: 'black'}}
                                    id="searchItem"
                                    type={'text'}
                                    value={this.state.idForAdd}
                                    onChange={this.IdForAddChanged}
                                    label="كتابة أسم الأنمي"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <ListItem onClick={this.openIdForOpened} button style={{margin: "7px", borderRadius: "8px",backgroundColor: "#2196f3", textAlign: "center",placeContent: "center"}}>
                                <Typography style={{fontFamily: "'Changa'",color: 'white'}}>
                                    بحث
                                </Typography>
                            </ListItem>
                        </ListItem>
                    </List>
                </Dialog>
                <Dialog open={this.state.idForOpened} onClose={this.closeIdForOpened}>
                    <List>
                        {this.state.animeList.map((item) => <ListItem key={item.id} onClick={this.IdForAdd.bind(this,item.id)}>
                            <ListItemAvatar>
                                <Avatar src={item.image}/>
                            </ListItemAvatar>
                            <ListItemText primary={item.name} />
                        </ListItem>)}
                    </List>
                </Dialog>
                <Dialog
                    fullScreen
                    onClose={() => this.closeAdd()}
                    open={this.state.addPost}
                >
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={this.state.backdrop}>
                        <CircularProgress style={{color: '#00b2ff'}} />
                    </Backdrop>
                    <Appbar.Header style={this.checkTheme() ? {backgroundColor: "#252e39"} : {backgroundColor: "#ffffff"}}>
                        <IconButton color="primary" aria-label="menu" onClick={this.closeAdd}>
                            <Icons.ArrowBack />
                        </IconButton>
                        <ContentTitle title="أنشاء منشور" subtitle={''} dark={this.checkTheme()} />
                    </Appbar.Header>
                    <List style={this.checkTheme() ? {backgroundColor: "#252e39",margin: "7px"} : {backgroundColor: "#ffffff",margin: "7px"}}>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>محتوى المنشور</InputLabel>
                                <OutlinedInput
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    id="searchItem"
                                    type={'text'}
                                    value={this.state.postItem.post}
                                    multiline={true}
                                    maxRows={5}
                                    dir="auto"
                                    onChange={this.changedPost}
                                    label="محتوى المنشور"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>رابط يوتيوب (غير مطلوب)</InputLabel>
                                <OutlinedInput
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    type={'text'}
                                    multiline={true}
                                    maxRows={2}
                                    dir="auto"
                                    id="addYoutube"
                                    value={this.state.postItem.youtube}
                                    onChange={this.changedYoutube}
                                    label="رابط يوتيوب (غير مطلوب)"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>رابط صورة (غير مطلوب)</InputLabel>
                                <OutlinedInput
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    type={'text'}
                                    multiline={true}
                                    maxRows={2}
                                    dir="auto"
                                    id="addImage"
                                    value={this.state.postItem.hasImage}
                                    onChange={this.changedImage}
                                    label="رابط صورة  (غير مطلوب)"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding: "0px"}}>
                            <Paper
                                sx={{
                                    backgroundColor: "transparent",
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexWrap: 'wrap',
                                    listStyle: 'none',
                                    p: 0.5,
                                    m: 0,
                                    boxShadow: "unset"
                                }}
                                component="ul"
                            >
                                {this.state.postItem.anime.map((data, index) => {
                                    let icon;
                                    icon = <TagOutlined style={this.checkTheme() ? {color: 'white'} : {color: 'black'}} />;
                                    return (
                                        <ListItemNew key={data.id}>
                                            <Chip
                                                style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                                icon={icon}
                                                deleteIcon={<DeleteOutline style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}/>}
                                                label={"رقم الأنمي : "+index.toString()}
                                                onDelete={this.deleteAnimeId.bind(this,data)}
                                            />
                                        </ListItemNew>
                                    );
                                })}
                                {this.state.postItem.anime.length < 5 ? <ListItemNew key={'addAnime'}>
                                    {
                                        this.state.postItem.anime.length === 0 ? <Chip clickable label={"أضف معرف أنمي (غير مطلوب)"} icon={<AddCircleOutline style={this.checkTheme() ? {color: 'white'} : {color: 'black'}} />} onClick={this.openIdForAdd} style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}/> : <Chip clickable label={'أضافة'} icon={<AddCircleOutline style={this.checkTheme() ? {color: 'white'} : {color: 'black'}} />} onClick={this.openIdForAdd} style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}/>
                                    }
                                </ListItemNew> : <Box/>}
                            </Paper>
                        </ListItem>
                        <ListItem>
                            <FormControlLabel control={<Switch checked={this.state.postItem.hasFire} onChange={this.hasFireChanged} />} label="يحتوي على حرق" />
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <ListItem onClick={this.sendPost} button style={{margin: "7px", borderRadius: "8px",backgroundColor: "#2196f3", textAlign: "center",placeContent: "center"}}>
                                <Typography style={{fontFamily: "'Changa'",color: 'white'}}>
                                    نشر
                                </Typography>
                            </ListItem>
                        </ListItem>
                    </List>
                </Dialog>
                <BottomSheet
                    onRequestClose={() => this.closeStory()}
                    open={this.state.bottomStory}
                >
                    <List style={this.checkTheme() ? {backgroundColor: "#252e39"} : {backgroundColor: "#ffffff"}}>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>محتوى المنشور</InputLabel>
                                <OutlinedInput
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    id="searchItem"
                                    type={'text'}
                                    value={this.state.postStory.post}
                                    multiline={true}
                                    maxRows={5}
                                    dir="auto"
                                    onChange={this.changedPostStory}
                                    label="محتوى المنشور"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <FormControl fullWidth focused color={"primary"} style={{margin: "5px"}} variant="outlined">
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>رابط صورة</InputLabel>
                                <OutlinedInput
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    type={'text'}
                                    multiline={true}
                                    maxRows={2}
                                    dir="auto"
                                    id="addImage"
                                    value={this.state.postStory.hasImage}
                                    onChange={this.changedImageStory}
                                    label="رابط صورة"
                                />
                            </FormControl>
                        </ListItem>
                        <ListItem style={{padding:"0px"}}>
                            <ListItem onClick={this.sendPostStory} button style={{margin: "7px", borderRadius: "8px",backgroundColor: "#2196f3", textAlign: "center",placeContent: "center"}}>
                                <Typography style={{fontFamily: "'Changa'",color: 'white'}}>
                                    نشر
                                </Typography>
                            </ListItem>
                        </ListItem>
                    </List>
                </BottomSheet>
                <Dialog
                    fullScreen={true}
                    onClose={this.closeComment}
                    open={this.state.comment}
                >
                    <Appbar.Header style={this.checkTheme() ? {backgroundColor: "#252e39"} : {backgroundColor: "#ffffff"}}>
                        <Appbar.Action icon="arrow-left" onPress={this.closeComment} />
                        <ContentTitle dark={this.checkTheme()} title={"التعليقات"} />
                        <Appbar.Action />
                    </Appbar.Header>
                    <List style={{width: "100%"}} sx={this.checkTheme() ? {backgroundColor: "#252e39"} : {backgroundColor: "#ffffff"}}>
                        <ListItem style={{padding: "3px"}}>
                            <FormControl fullWidth focused color={"primary"} style={this.checkTheme() ? {backgroundColor: '#2c3846'} : {backgroundColor: '#f8f6f6'}}>
                                <InputLabel style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}>أكتب هنا</InputLabel>
                                <OutlinedInput
                                    dir={'auto'}
                                    style={this.checkTheme() ? {color: 'white'} : {color: 'black'}}
                                    id="addCmd"
                                    type={'text'}
                                    value={this.state.commentString}
                                    onChange={this.changedComment}
                                    label="أكتب هنا"
                                />
                            </FormControl>
                            <ListItemAvatar style={{minWidth: "unset",marginLeft: "4px",marginRight: "4px"}}>
                                <IconButton onClick={this.sendCmd} style={this.checkTheme() ? {backgroundColor: '#2c3846'} : {backgroundColor: '#ebebeb'}}>
                                    <SendOutlined />
                                </IconButton>
                            </ListItemAvatar>
                        </ListItem>
                    </List>
                    <Box style={{marginBottom: '7px'}} height={'100%'}>
                        {this.state.commentLoading ? <CenterLoading/> : <List style={{paddingTop: '0px', paddingBottom: '0px',paddingLeft: "0px", paddingRight: "0px"}}>
                            {this.state.commentData.length === 0 ? <CenterEmpty/> : this.state.commentData.map(item =>
                                <ListItem style={{paddingLeft: "7px", paddingRight: "7px"}} key={item.id}>
                                    <Card sx={{ width: "100%",borderRadius: "8px" }}>
                                        <CardHeader
                                            avatar={
                                                item.admin.toString().includes("true") ? <Tooltip title="الأدارة">
                                                    <Badge anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    }} badgeContent={<Done style={{color: 'white'}} sx={{ fontSize: 12 }}/>} overlap="circular" sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 14, minWidth: 14, width: 14 } }} color="primary">
                                                        <Avatar aria-label="recipe" src={item.userimage}/>
                                                    </Badge>
                                                </Tooltip> : <Avatar aria-label="recipe" src={item.userimage}/>
                                            }
                                            title={item.hasPremium !== "1" ? item.username : <Box>
                                            <span style={{color: "gold", textShadow: '0px 0px 5px #ffeb3b'}}>
                                                {item.username}
                                            </span>
                                            </Box>}
                                            subheader={<Typography style={{fontSize: "14px",opacity: "0.8"}}>{item.time}</Typography>}
                                        />
                                        <CardContent style={{textAlign: "unset"}} dir="auto">
                                            <Typography style={{width: "100%",textAlign: "initial",whiteSpace: "pre-line"}} dir="auto" aria-multiline={true}>
                                                {item.post}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </ListItem>
                            )}
                        </List> }
                    </Box>
                </Dialog>

                <Dialog fullScreen open={this.state.storyDataDialog} onClose={this.storyDataDialogClose}>
                    <ImageListItem style={{height: '100%'}}>
                        <img
                            src={this.state.storyData.image}
                            alt={this.state.storyData.user}
                            loading="lazy"
                        />
                        <ImageListItemBar
                            className={'myStory'}
                            title={this.state.storyData.text}
                            position="bottom"
                        />
                        <ImageListItemBar
                            sx={{
                                background:
                                    'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                                    'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                            }}
                            title={this.state.storyData.hasPremium !== "1" ? this.state.storyData.user : <Box>
                                            <span style={{color: "gold", textShadow: '0px 0px 5px #ffeb3b'}}>
                                                {this.state.storyData.user}
                                            </span>
                            </Box>}
                            subtitle={<Typography style={{fontSize: "14px",opacity: "0.8",color: "white"}}>{this.state.storyData.time}</Typography>}
                            position="top"
                            actionIcon={
                                <IconButton
                                    onClick={this.storyDataDialogClose}
                                    sx={{ color: 'white' }}
                                    aria-label={'back button'}
                                >
                                    <ArrowBack style={{color: "white"}} />
                                </IconButton>
                            }
                            actionPosition="left"
                        />
                    </ImageListItem>
                </Dialog>
            </Box>
        }
    }
}
const ContentTitle = ({ title, subtitle, dark }) => {
    if (dark) {
        return (<Appbar.Content
            title={<Text style={{fontFamily: "Righteous", color: 'white'}}>{title}</Text>}
            subtitle={<Text style={{fontFamily: "Changa", color: 'white'}}>{subtitle}</Text>}
            style={{alignItems: 'left'}}
        />);
    } else {
        return (<Appbar.Content
                title={<Text style={{fontFamily: "Righteous", color: 'black'}}>{title}</Text>}
                subtitle={<Text style={{fontFamily: "Changa", color: 'black'}}>{subtitle}</Text>}
                style={{alignItems: 'left'}}
            />
        );
    }
};
